export type {
    AgentRunProgress,
    AgentRunProposal,
    AgentRunProposalClaim,
    AgentRunProposalItem,
    AgentRunProposalTool,
    AgentRunRow,
    AgentRunScope,
    AgentRunSummary,
    AgentRunTaskMemory,
    WaitingOnEntry,
} from "@common/schemas/domains/agentRuns/agent-run.schema";

// Same vocabulary as the Datadog `agent.step` events; the worker reports the
// last one into `agent_run.progress` and the Agent panel reads it back.
export const AGENT_RUN_STEPS = [
    "run_started",
    "close_selected",
    "template_checked",
    "bootstrapped",
    "segment_started",
    "firm_skills_resolved",
    "segment_completed",
    "tool_called",
    "write_gated",
    "claim_verified",
    "applies_persisted",
    "proposal_posted",
    "comment_posted",
    "status_updated",
    "stage_updated",
    "relation_updated",
    "parked",
    "paused",
    "resumed",
    "wait_resolved",
    "task_status_changed",
    "wait_dropped",
    "signal_sent",
    "usage_recorded",
    "tool_calls_recorded",
    "finished",
] as const;
export type AgentRunStep = (typeof AGENT_RUN_STEPS)[number];

export type {
    JsonValue as AgentRunJsonValue,
    JsonObject as AgentRunJsonObject,
} from "@common/types/json";

export enum AgentRunState {
    running = "running",
    waiting = "waiting",
    done = "done",
    failed = "failed",
    cancelled = "cancelled",
    expired = "expired",
}

export enum AgentRunWaitKind {
    proposal = "proposal",
    answer = "answer",
    status = "status",
}

export enum AgentRunMode {
    propose = "propose",
    apply = "apply",
}

export enum AgentToolCallStatus {
    ok = "ok",
    error = "error",
    preview = "preview",
}

export enum AgentRunProposalStatus {
    proposed = "proposed",
    applying = "applying",
    applied = "applied",
    declined = "declined",
    partial = "partial",
}
